export const IMAGE_ASPECT_RATIO = { width: 16, height: 9 };

export default IMAGE_ASPECT_RATIO;
